export const buildMapsSearch = (text) => `https://maps.app.goo.gl/?q=${encodeURIComponent(text||"")}`;
export const normalizeMapUrl = (url, fallbackText) => {
  const u = (url||"").trim();
  if (!u) return buildMapsSearch(fallbackText||"");
  // Accept full https URLs
  if (u.startsWith("https://")) return u;
  if (u.startsWith("http://")) return u.replace("http://","https://");
  if (u.startsWith("www.")) return `https://${u}`;
  // If it looks like google maps path or plain address -> use universal maps link
  return buildMapsSearch(u);
};
